import ClaudeIcon from '@/assets/icons/claude.svg?react';
import OpenAiIcon from '@/assets/icons/openai.svg?react';

type AgentLogoProps = { agent: 'claude-code' | 'codex'; isCompact?: boolean };

/** The agent's mark: a 40 px tile on cards, the bare 16 px mark in lists. */
export function AgentLogo({ agent, isCompact = false }: AgentLogoProps) {
  const Icon = agent === 'claude-code' ? ClaudeIcon : OpenAiIcon;
  if (isCompact) return <Icon aria-hidden="true" className="size-4 shrink-0" />;
  return (
    <span className="inline-flex size-10 shrink-0 items-center justify-center rounded-logo bg-surface-2">
      <Icon className="size-5" />
    </span>
  );
}
